import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import { fetchProfileDataAction } from '../../../store/actions/profile';
import { addBankAccount } from '../../../services/backendAPI';

const useBankForm = () => {
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        account_type: 'SAVINGS',
        bank_account_number: '',
        bank_name: '',
        city: '',
        ifsc: '',
        state: '',
        address: 'temp',
        otp: ''
    });

    const handleChange = useCallback((e, onIFSCLookup, onClearError) => {
        const { name, value } = e.target;
        let updatedValue = value;

        if (name === 'ifsc') {
            updatedValue = value.toUpperCase();
            if (updatedValue.length === 11 && onIFSCLookup) {
                onIFSCLookup(updatedValue);
            }
        }

        setFormData(prev => ({
            ...prev,
            [name]: updatedValue
        }));

        if (onClearError) {
            onClearError(name);
        }
    }, []);

    const updateFormData = useCallback((updates) => {
        setFormData(prev => ({ ...prev, ...updates }));
    }, []);

    const resetForm = useCallback(() => {
        setFormData({
            account_type: 'SAVINGS',
            bank_account_number: '',
            bank_name: '',
            city: '',
            ifsc: '',
            state: '',
            address: 'temp',
            otp: ''
        });
    }, []);

    const handleSubmit = useCallback(async (validateForm, onError) => {
        if (!validateForm(formData)) return;

        setLoading(true);
        try {
            const response = await addBankAccount(formData);

            if (response?.status === 'success') {
                dispatch(fetchProfileDataAction());
                enqueueSnackbar(response?.message || 'Bank account added successfully', {
                    variant: 'success'
                });
                return true; // Success
            } else {
                onError('submit', response?.message || 'Failed to add bank account');
                return false;
            }
        } catch (error) {
            enqueueSnackbar(error?.message || error?.toString() || 'Failed to add bank account', {
                variant: 'error',
                autoHideDuration: 1000,
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                }
            });
            return false;
        } finally {
            setLoading(false);
        }
    }, [formData, dispatch, enqueueSnackbar]);

    return {
        formData,
        loading,
        handleChange,
        updateFormData,
        resetForm,
        handleSubmit
    };
};

export default useBankForm;
